module.exports = {
  B2B: 'b2b',
  B2C: 'b2c',
};
